import { InboxOutlined } from '@ant-design/icons';
import { message, Spin, Upload } from 'antd';
import { observer, useLocalStore } from 'mobx-react';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { useStore } from '../stores';

const Result = styled.div`
    margin-top:30px;
    padding:20px;
    border:1px dashed #ccc;

`;

const H1 = styled.h1`
    margin:20px 0;
    text-align:center;
`;

const Imge = styled.img`
    max-width:300px;
`;

const { Dragger } = Upload;

// 当前组件并没有订阅信息，所以当该改变一次后就不再发生改变了
// 我们需将当前组件作为observer的参数，需要boserver作为一个观察者来观察当前组件
const Component = observer(() => {
    // 解构imageStore
    const { ImageStore, UserStore } = useStore();
    const ref1 = useRef();
    const ref2 = useRef();
    const store = useLocalStore(() => ({
        width: null,
        setWidth(width) {
            store.width = width;
        },
        get widthStr() {
            return store.width ? `/w/${store.width}` : '';
        },
        height: null,
        setHeight(height) {
            store.height = height;
        },
        get heightStr() {
            return store.height ? `/h/${store.height}` : '';
        },
        get fullStr() {
            // /imageView2/0/w/800/h/400
            return ImageStore.serverFile.attributes.url.attributes.url + '?imageView2/0' + store.widthStr + store.heightStr;
        }
    }))

    const bindWidthChange = () => {
        store.setWidth(ref1.current.value);
    }
    const bindHeightChange = () => {
        store.setHeight(ref2.current.value);
    }

    const props = {
        showUploadList: false,
        beforeUpload: file => {
            ImageStore.setFile(file);
            ImageStore.setFilename(file.name);
            // 图片上传之之前做个登陆判断
            if (UserStore.currentUser === null) {
                message.warning('请先登录再上传！！！');
                // 一定要有return false ,否则代码会继续执行上传
                return false;
            }
            window.file = file;
            // 上传图片之前做个图片类型判断,//ig用来忽略大小写
            if (!/(svg$)|(png$)|(jpg$)|(jpeg$)|(gif$)/ig.test(file.type)) {
                message.error('只能上传svg/png/jpg/jpeg/gif格式的图片');
                return false;
            }
            // 判断图片大小
            if (file.size > 1024 * 1024) {
                message.error('图片最大不能超过1M');
                return false;
            }

            ImageStore.upload()
                .then((serverFile) => {
                    console.log('上传成功');
                    console.log(serverFile);
                }).catch(() => {
                    console.log('上传失败');
                });
            return false;
        }
    }

    return (
        <div>
            <Spin tip="上传中..." spinning={ImageStore.isUploading}>
                <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">点击或者拖拽上传图片</p>
                    <p className="ant-upload-hint">
                        仅支持.png/.jpg/.gif/.svg格式的图片，图片最大1M
                    </p>
                </Dragger>
            </Spin>


            {
                ImageStore.serverFile ?
                    <Result>
                        <H1>上传结果</H1>
                        <dl>
                            <dt>线上地址</dt>
                            <dd><a target="_blank" rel="noopener noreferrer" href={ImageStore.serverFile.attributes.url.attributes.url}>{ImageStore.serverFile.attributes.url.attributes.url}</a></dd>
                            <dt>文件名</dt>
                            <dd>{ImageStore.filename}</dd>
                            <dt>图片预览</dt>
                            <dd><Imge src={ImageStore.serverFile.attributes.url.attributes.url} alt="" /></dd>
                            <dt>定制图片</dt>
                            <dd>
                                <input ref={ref1} onChange={bindWidthChange} placeholder="最大宽度（可选)" />
                                <input ref={ref2} onChange={bindHeightChange} placeholder="最大高度(可选)" />

                            </dd>
                            <dd>
                                <a target="_blank" rel="noopener noreferrer" href={store.fullStr}>{store.fullStr}</a>
                            </dd>
                        </dl>

                    </Result>
                    : null


            }
        </div>
    )
});

export default Component;